export interface PasswordRule {
  label: string;
  met: boolean;
}

interface PasswordValidationResult {
  valid: boolean;
  rules: PasswordRule[];
}

export function validatePassword(password: string): PasswordValidationResult {
  const rules: PasswordRule[] = [
    { label: "At least 8 characters", met: password.length >= 8 },
    { label: "At least one uppercase letter", met: /[A-Z]/.test(password) },
    { label: "At least one lowercase letter", met: /[a-z]/.test(password) },
    { label: "At least one number", met: /[0-9]/.test(password) },
    {
      label: "At least one special character",
      met: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(password),
    },
  ];

  return { valid: rules.every((r) => r.met), rules };
}
